import { Component, Inject, OnInit, OnChanges, Input, SimpleChanges, SimpleChange, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { environment } from '../../../../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';
import { ConfigService } from '../../../../../../services/config/config.service';
import { ClipboardService } from 'ngx-clipboard';
import { EmployeeService } from '../../../../../../services/employee/employee.service';
import {MatSnackBar} from '@angular/material';

@Component({
    selector: 'fuse-employee-mail-configuration',
    templateUrl: './employee-mail-configuration.component.html',
    styleUrls: ['./employee-mail-configuration.component.scss'],
    animations: fuseAnimations
})
export class EmployeeMailConfigurationComponent implements OnInit, OnChanges {
    formGroup;

    @ViewChild('myBtn') myBtn: ElementRef;
    public attrs = [];
    public typeEmployees = [];
    public jobTitles = [];
    public shifts = [];
    mailsList = '';
    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EmployeeMailConfigurationComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        private jobTitleService: JobTitleService,
        private employeeService: EmployeeService,
        private configService: ConfigService,
        private _clipboardService: ClipboardService,
        public snackBar: MatSnackBar
    ) {
        console.log('FuseAddStudentComponent > data', data);
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.typeEmployeeService.getAll(),
            this.jobTitleService.getAll(),
            this.shiftService.getAll(),
            this.configService.getEmployeeAttrs()
        ).subscribe(([typeEmployees, jobTitles, shifts, employeeAttrs]) => {
            this.typeEmployees = typeEmployees.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.jobTitles = jobTitles.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.shifts = shifts.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            employeeAttrs.forEach(e => {
                e.Checked = false;
            });

            this.attrs = employeeAttrs;

            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }


    save() {
        const attrs = this.attrs.filter(e => e.Checked).map(e => e.Code);
        const typeEmployees = this.typeEmployees.filter(e => e.Checked).map(e => e.Id);
        const jobTitles = this.jobTitles.filter(e => e.Checked).map(e => e.Id);
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        console.log('d', environment.backendUri + 'report/excel/employee/' + attrs + '/' + jobTitles + '/' + typeEmployees + '/' + shifts);
        window.open(environment.backendUri + 'report/excel/employee/' + attrs + '/' + jobTitles + '/' + typeEmployees + '/' + shifts, '_new');
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
          duration: 2000,
        });
      }

    callServiceToCopy() {
        this.blockUI.start('Cargando datos...');
//console.log('(this.myBtn', this.myBtn);
//console.log('(this.myBtn.nativeElement', this.myBtn.nativeElement);


        const jobTitles = this.jobTitles.filter(e => e.Checked).map(e => e.Id);
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        console.log(jobTitles);
        this.employeeService.getMails(shifts, jobTitles).subscribe(response => {
            this.blockUI.stop();
            console.log('SchoolDataComponent > ngOnInit > this.schooldataService.getdata()', response);
            this.mailsList = response;

            console.log('*********** ' + this.mailsList);            
            //this.renderer.selectRootElement(this.myBtn.nativeElement).click();
            //this.myBtn.nativeElement.dispatchEvent(new CustomEvent('click'));
            //let el: HTMLElement = this.myBtn.nativeElement as HTMLElement;
            //el.click();
        }, error => {
            this.blockUI.stop();
            this.sweetAlertService.error('Error', 'Ocurrio un error al traer los turnos.', null);
        });
        //this._clipboardService.copyFromContent(this.mailsList);
    }

    copyMails(mailsList: string) {
        console.log('************** paso 2 +' + mailsList);
        this._clipboardService.copyFromContent(mailsList);
    }

    onCopyFailure() {
        this.blockUI.stop();
        alert('copy fail!');
    }

    ngOnChanges()
    {
            console.log('++++++++++++' + this.mailsList);
            //this._clipboardService.copyFromContent(this.mailsList);
            return;
        // }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/components/employee-mail-configuration/employee-mail-configuration.component.ts